import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const AuthHandler = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const mode = searchParams.get("mode");
  const oobCode = searchParams.get("oobCode");

  useEffect(() => {
    if (!mode || !oobCode) {
      navigate("/"); // fallback dacă lipsesc parametrii
      return;
    }

    switch (mode) {
      case "verifyEmail":
        navigate(`/verify?oobCode=${oobCode}`);
        break;
      case "resetPassword":
        navigate(`/reset-password?oobCode=${oobCode}`);
        break;
      default:
        navigate("/");
    }
  }, [mode, oobCode, navigate]);

  return <div className="container text-center py-5">Redirecting...</div>;
};

export default AuthHandler;
